import { useEffect, useState } from 'react';
import { MdInstallMobile } from 'react-icons/md';
export default function InstallApp() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(() => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);
  useEffect(() => {
    const ready = event => { event.preventDefault(); setPrompt(event); };
    const done = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', ready); window.addEventListener('appinstalled', done);
    return () => { window.removeEventListener('beforeinstallprompt', ready); window.removeEventListener('appinstalled', done); };
  }, []);
  if (installed) return null;
  return <section className="mobile-install"><MdInstallMobile size={28} aria-hidden="true" /><div><strong>Wozzap sulla schermata Home</strong><p>Aprila a tutto schermo, come un’app.</p>
    {prompt ? <button onClick={async () => { await prompt.prompt(); await prompt.userChoice; setPrompt(null); }}>Installa Wozzap</button> : <p className="install-help">Su iPhone: Condividi → Aggiungi alla schermata Home. Su Android: menu del browser → Installa app. Richiede HTTPS.</p>}
  </div></section>;
}
